import {
  React,
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { NavBar } from "../Navbar/NavBar";
import { ClipLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Modal, TextField, Box } from "@material-ui/core";
import "./settlementTracker.css";
import moment from "moment";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";

const SettlementTracker = () => {
  const [collections, setCollections] = useState([]);
  const [activeOrder, setActiveOrder] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalOrders, setTotalOrders] = useState();
  const [totalSettled, setTotalSettled] = useState(0);
  const [orders, setOrders] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [selectedOrderBalance, setSelectedOrderBalance] = useState(null);
  const [enteredAmount, setEnteredAmount] = useState("");
  const [collectedDate, setCollectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const navigator = useNavigate();
  const [lastSearchQuery, setLastSearchQuery] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [selectedCollectionId, setSelectedCollectionId] = useState(null);
  const [orderInputs, setOrderInputs] = useState({});
  const [isInputValid, setInputValid] = useState(true);

  const [platformChargesModal, setPlatformChargesModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState({});

  console.log(orderInputs, "===========");

  const fetchOrdersAndCollections = useCallback(
    async (searchQuery = "") => {
      setLoading(true);
      const start = (currentPage - 1) * pageSize;
      const length = pageSize;
      const token = localStorage.getItem("token");
      try {
        const collectionsRes = await axios.get(
          `/workflow/api/banking/collections?start=${start}&length=${length}&shop_name=${encodeURIComponent(
            searchQuery
          )}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(collectionsRes.data);
        const collectionsData = collectionsRes.data.collection_data;
        const ordersData = await Promise.all(
          collectionsData.map(async (collection) => {
            const amount = collection.ayekart_remaining_amount;
            const ordersRes = await axios.get(
              `/workflow/api/banking/collections/orders?shop_name=${encodeURIComponent(
                collection.name
              )}&amount=${encodeURIComponent(amount)}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
            console.log(ordersRes?.data?.orders || []);
            return ordersRes?.data?.orders || [];
          })
        );
        const orderInputs = {};
        ordersData.forEach((orders, collectionIndex) => {
          const collectionId = collectionsData[collectionIndex]?.collection_id;
          orders.forEach((order) => {
            const settledValue = parseFloat(order?.settled);
            if (!orderInputs[collectionId]) {
              orderInputs[collectionId] = {};
            }
            orderInputs[collectionId][order?.order_id] = isNaN(settledValue)
              ? order?.settled
              : settledValue.toFixed(2);
          });
        });
        setOrderInputs(orderInputs);
        setLoading(false);
        setCollections(collectionsData);
        setTotalOrders(collectionsRes.data.count);
        setPaymentDate(
          collectionsData.map((collection) => collection.payment_date)
        );
        let uniqueOrdersData = [
          ...new Map(
            ordersData.flat().map((item) => [item.order_id, item])
          ).values(),
        ];
        setOrders(uniqueOrdersData);
        setLastSearchQuery(searchQuery);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data: ", error);
        // toast.error("An error occurred while fetching data. Please try again.");
      }
    },
    [currentPage, pageSize]
  );

  const settleOrder = async (collectionData, balanceDue) => {
    const collectionId = collectionData?.collection_id;

    const selectedCollection = collections.find(
      (collection) => collection.collection_id === selectedCollectionId
    );
    const bank = selectedCollection ? selectedCollection.bank : null;
    const collectionRecievedDate = selectedCollection
      ? selectedCollection.payment_date
      : null;

    const url = `/workflow/api/banking/collections/orders`;
    const selectedOrder = orders.find(
      (order) => order.order_id === selectedOrderId
    );

    const enteredOrderAmount = selectedOrder
      ? String(parseFloat(selectedOrder.settled).toFixed(2))
      : "0";

    const totalAmount = selectedOrder ? parseFloat(selectedOrder.amount) : 0;
    const extraAmount = 1.002 * totalAmount - totalAmount;
    const balanceDueWithExtra = parseFloat(balanceDue) + extraAmount;

    if (parseFloat(enteredOrderAmount) > balanceDueWithExtra) {
      console.log(
        `Error: Entered amount (${enteredOrderAmount}) exceeds the maximum allowed value (${balanceDueWithExtra.toFixed(
          2
        )}).`
      );
      toast.error("Entered amount exceeds the maximum allowed value");
      return;
    }

    /*if (parseFloat(enteredOrderAmount) > 1.002 * totalAmount) {
      console.log(
        `Error: Entered amount (${enteredOrderAmount}) is more than 1.002 times the total amount (${totalAmount}).`
      );
      toast.error("Entered amount is more than balance due");
      return;
    }*/

    let currentPartialPaymentData = selectedOrder
      ? selectedOrder.partial_payment_data
      : [];

    if (!currentPartialPaymentData) {
      currentPartialPaymentData = [];
    }

    let maxId = 0;
    currentPartialPaymentData.forEach((payment) => {
      if (typeof payment === "string") {
        payment = JSON.parse(payment);
      }

      if (payment.id > maxId) {
        maxId = payment.id;
      }
    });
    const newId = maxId + 1;
    const parsedPartialPaymentData = currentPartialPaymentData.map(
      (payment) => {
        if (typeof payment === "string") {
          return JSON.parse(payment);
        }
        return payment;
      }
    );
    const paymentStatus =
      enteredOrderAmount >= selectedOrderBalance
        ? "Fully Paid"
        : "Partially Paid";
    console.log(`Payment Status: ${paymentStatus}`);
    const body = {
      order_id: selectedOrderId,
      collection_id: selectedCollectionId,
      bank: bank,
      paid_amount: enteredOrderAmount,
      collection_recieved_date: collectionRecievedDate,
      partial_payment_data: [
        ...parsedPartialPaymentData,
        {
          id: newId,
          operation_status: "Collected",
          finance_status: "Amount Received",
          amount_collected: enteredOrderAmount,
          payment_status: paymentStatus,
          amount_collected_date: new Date(collectedDate),
          finance_confirm_date: new Date(collectedDate),
          stage_9_actioner: userDetails?.user_name,
          stage_9_stamp: new Date(collectedDate),
          stage_10_actioner: userDetails?.user_name,
          stage_10_stamp: new Date(collectedDate),
        },
      ],
    };

    try {
      const token = localStorage.getItem("token");
      const response = await axios.patch(url, body, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.status === false) {
        toast.error(response.data.message || "An error occurred");
      } else {
        toast.success("Order Settled Successfully");
        console.log("Order settled successfully");
        fetchOrdersAndCollections(lastSearchQuery);
      }
    } catch (error) {
      console.error("Error settling order: ", error);
      toast.error("Network error occurred");
    }
  };

  const handlePlatformChargesOpen = (orderId, event) => {
    event.preventDefault();
    const selectedOrder = orders.find((order) => order.order_id === orderId);

    setSelectedOrder(selectedOrder);
    setPlatformChargesModal(true);
  };

  const handleOpen = (orderId, collectionId, event) => {
    event.preventDefault();

    const selectedOrder = orders.find((order) => order.order_id === orderId);
    const balanceDue = selectedOrder ? selectedOrder.balance_due_amount : 0;

    setSelectedOrderId(orderId);
    setSelectedCollectionId(collectionId);
    const selectedCollection = collections.find(
      (collection) => collection.collection_id === collectionId
    );
    setSelectedOrderBalance(balanceDue);
    setOpen(true);
  };

  const handlePlatformChargesClose = () => {
    setPlatformChargesModal(false);
    setSelectedOrder({});
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedOrderId(null);
    setSelectedOrderBalance(null);
  };

  const handleChange = (e, orderId, collectionId) => {
    let enteredValue = e.target.value;
    if (parseFloat(enteredValue) < 0) {
      toast.error("Invalid input: amount cannot be negative");
      setInputValid(false);
      return;
    }

    const collection = collections.find(
      (collection) => collection.collection_id === collectionId
    );

    const remainingToSettle = parseFloat(
      collection.ayekart_remaining_amount
    ).toFixed(2);

    if (parseFloat(enteredValue) > parseFloat(remainingToSettle)) {
      toast.error("Entered amount exceeds the remaining to Settle Amount");
      setInputValid(false);
      return;
    }

    setOrderInputs((prevOrderInputs) => ({
      ...prevOrderInputs,
      [collectionId]: {
        ...prevOrderInputs[collectionId],
        [orderId]: enteredValue,
      },
    }));

    setActiveOrder(orderId);
    const updatedOrders = orders.map((order) =>
      order.order_id === orderId
        ? { ...order, settled: parseFloat(enteredValue) }
        : { ...order }
    );
    setOrders(updatedOrders);
    setEnteredAmount(parseFloat(enteredValue));
    setInputValid(true);
  };

  const debounce = (callback, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        timeoutId = null;
        callback(...args);
      }, delay);
    };
  };

  const debouncedFetchOrdersAndCollections = debounce(
    fetchOrdersAndCollections,
    500
  );

  const settlePlatformCharges = async () => {
    const platformId = selectedOrder.platform_id;
    const amount = selectedOrder.total_platform_charges || 0;
    const collectionDate = moment(new Date(), "YYYY-MM-DD");
    const actioner = JSON.parse(localStorage.getItem("user_detail")).user_name;

    const payload = {
      collection_status: "COLLECTED",
      collection_amount: amount,
      collection_date: collectionDate,
      actioner: actioner,
      action_stamp: collectionDate,
    };
    const url = `/api/platform/charges/${platformId}`;
    try {
      const token = localStorage.getItem("token");
      const response = await axios.patch(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.status === false) {
        toast.error(response.data.message || "An error occurred");
      } else {
        toast.success("Platform Charges Settled Successfully");
        console.log("Platform Charges Settled successfully");
        fetchOrdersAndCollections(lastSearchQuery);
      }
    } catch (error) {
      console.error("Error Settling Platform Charges: ", error);
      toast.error("Network error occurred");
    }
  };

  useEffect(() => {
    debouncedFetchOrdersAndCollections(searchQuery);
  }, [currentPage, searchQuery]);

  let collectionData;
  if (collections) {
    collectionData = collections.find((collection) => collection.name);
  }

  /*------------------------------------- Pagination Code Start------------------------------*/

  const goToPreviousPage = (e) => {
    e.preventDefault();
    if (currentPage > 1) {
      const previousPage = currentPage - 1;
      const start = (previousPage - 1) * pageSize;
      setCurrentPage(previousPage);
    }
  };

  // Handle click event for next page
  const goToNextPage = (e) => {
    e.preventDefault();
    const totalPages = Math.ceil(totalOrders / pageSize);
    if (currentPage < totalPages) {
      const nextPage = currentPage + 1;
      const start = (nextPage - 1) * pageSize;
      setCurrentPage(nextPage);
    }
  };

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(totalOrders / pageSize);
  const maxVisiblePages = 5;
  let startPage = Math.max(currentPage - Math.floor(maxVisiblePages / 2), 1);
  let endPage = startPage + maxVisiblePages - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(endPage - maxVisiblePages + 1, 1);
  }

  const pageNumbers = Array.from(
    { length: endPage - startPage + 1 },
    (_, index) => startPage + index
  );

  const handlePageClick = (event, page) => {
    event.preventDefault();
    const start = (page - 1) * pageSize;
    setCurrentPage(page);
  };

  /*------------------------------------- Pagination Code End------------------------------*/

  const formatNumberWithCommas = (number) => {
    return number
      ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      : "";
  };

  return (
    <div className="flex">
      <div className="mt-3 ml-8 builk-main ">
        {loading ? (
          <div className="fixed top-0 left-0 right-0 bottom-0 bg-gray-900 bg-opacity-50 flex items-center justify-center">
            <ClipLoader color="#4A1AC7" size={50} />
          </div>
        ) : null}
        {/*------------------------------------------- Tabs List Started --------------------------------------- */}
        <ToastContainer />
        {/*------------------------------------------- Tabs List Ended --------------------------------------- */}
        {/*------------------------------------------- Lending Partner Starts --------------------------------------- */}
        <div className="text-gray-500 p-2 mt-20">
          <section className="fluid w-full px-2">
            <div className="flex justify-end text-gray-900 m-0">
              <Button
                variant="contained"
                style={{ background: "#343A40" }}
                onClick={() => navigator("/revoke-tracker")}
              >
                Edit settlement Tracker
              </Button>
            </div>

            <div className="flex items-right justify-end space-x-5">
              {/* Search input */}
              <input
                className="shadow-lg shadow-cyan-500/50 rounded-md w-100 h-10 mt-2 border border-gray-300 py-2 px-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-50 dark:focus:ring-gray-400 dark:focus:ring-offset-gray-900"
                type="text"
                placeholder="Search Party Name"
                onChange={(e) => {
                  setSearchQuery(e.target.value);
                  debouncedFetchOrdersAndCollections(e.target.value);
                }}
              />
            </div>

            {/* Orders table */}
            <div className="flex flex-col mt-2">
              <div className="overflow-x-auto bg-cyan-500 shadow-lg shadow-cyan-500/50">
                <div className="inline-block min-w-full py-2 align-middle bg-cyan-500 shadow-lg shadow-cyan-500/50">
                  <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg bg-cyan-500 shadow-lg shadow-cyan-500/50">
                    <div className="table-container">
                      <table className="min-w-full bg-cyan-500 shadow-lg shadow-cyan-500/50">
                        <thead className="bg-gray-50 dark:bg-gray-800 ">
                          <tr className="divide-x">
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 py-3.5 px-4 text-lg font-normal text-center text-white dark:text-white"
                            >
                              <span>Date</span>
                            </th>
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 px-12 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                            >
                              Amount Received
                            </th>
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 px-4 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                            >
                              Party
                            </th>
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 px-4 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                            >
                              Bank
                            </th>
                            <th
                              scope="col"
                              className="rounded-md bg-gray-900 px-4 py-3.5 text-lg font-normal text-center text-white dark:text-white"
                            >
                              UTR No
                            </th>

                            <th
                              scope="col"
                              className="rounded-md whitespace-nowrap bg-gray-900 px-4 py-3.5 text-lg font-normal text-center text-white dark:text-white w-full"
                            >
                              Order Wise Fund Allocation
                            </th>
                          </tr>
                        </thead>
                        {/* Table body */}
                        <tbody className="bg-white dark:bg-gray-900 overflow-y-auto">
                          {collections?.map((collection, index) => {
                            const collectionOrders = orders.filter(
                              (order) => order.name === collection.name
                            );
                            return (
                              <tr
                                className={`divide-x ${
                                  index % 2 === 0 ? "bg-gray-100" : "bg-white"
                                }`}
                                key={collection.utr}
                              >
                                <td className="py-4 px-4  text-center rounded-md">
                                  <div className="text-sm font-medium text-gray-900 dark:text-white">
                                    {collection.payment_date || "N/A"}
                                  </div>
                                </td>
                                <td className="px-12 py-4 whitespace-nowrap text-center rounded-md">
                                  <div className="text-lg text-gray-900 dark:text-white mb-auto">
                                    {` ₹ ${formatNumberWithCommas(
                                      collection.amount
                                    )}`}
                                    <br />
                                    <div className="mt-2 mb-2 text-xl font-bold">
                                      Remaining <br /> to settle
                                    </div>

                                    <span className="bg-green-700 text-white py-1 px-2 rounded text-xl">
                                      {` ₹ ${formatNumberWithCommas(
                                        Number(
                                          collection.ayekart_remaining_amount
                                        ).toFixed(2)
                                      )}`}
                                    </span>
                                  </div>
                                </td>

                                <td className="px-12 py-4  text-center rounded-md">
                                  <div className="text-sm text-gray-900 dark:text-white">
                                    {collection.name}
                                  </div>
                                </td>
                                <td className="py-4 px-4  text-center rounded-md">
                                  <div className="text-sm font-medium text-gray-900 dark:text-white">
                                    <span className="bg-dark text-white py-1 px-2 rounded text-xl">
                                      {collection.bank}
                                    </span>
                                  </div>
                                </td>
                                <td className="px-12 py-4 whitespace-nowrap text-center rounded-md">
                                  <div className="text-sm text-gray-900 dark:text-white">
                                    {collection.utr}
                                  </div>
                                </td>

                                <div className="scrollable-content bg-white mb-4 shadow-gray-950 rounded-2xl	mt-6 mr-2 ">
                                  {/* <div className="flex justify-center sticky top-0">
                                    <div className="w-full text-xl bg-blue-900  text-white shadow-xl mt-0  rounded-full text-center">
                                      Order Data
                                    </div>
                                  </div> */}

                                  {[...collectionOrders]
                                    .sort((a, b) => a.order_id - b.order_id)
                                    .map((order) => (
                                      <tr key={order.order_id} className=" ">
                                        <td className="px-3 py-2">
                                          <div className="font-normal ">
                                            OrderID:
                                          </div>
                                          <div className="bg-gray-800  text-white py-1 px-2 rounded mt-1 text-center text-sm font-bold">
                                            {order.order_id}
                                          </div>
                                        </td>
                                        <td className="px-3 py-2">
                                          <div className="font-normal">
                                            Order Amount:
                                          </div>
                                          <div className="bg-gray-800 whitespace-nowrap text-white py-1 px-2 rounded mt-1 text-center text-sm font-bold">
                                            {` ₹ ${formatNumberWithCommas(
                                              Number(order.amount).toFixed(2)
                                            )}`}
                                          </div>
                                        </td>
                                        <td className="px-3 py-2">
                                          <div className="font-normal whitespace-nowrap">
                                            Balance Due:
                                          </div>
                                          <div className="bg-red-700 whitespace-nowrap text-white py-1 px-2 rounded mt-1 text-center text-sm font-bold">
                                            {` ₹ ${formatNumberWithCommas(
                                              Number(
                                                order.balance_due_amount
                                              ).toFixed(2)
                                            )}`}
                                          </div>
                                        </td>
                                        <td className="px-4 py-2 flex flex-col  border-none ml-3">
                                          <div>
                                            <input
                                              className=" mt-2 rounded-md border whitespace-nowrap bg-white px-3 py-2 text-sm w-40 mb-2"
                                              type="number" onWheel={(e) => e.target.blur()}
                                              placeholder="Enter Amount"
                                              value={
                                                orderInputs[
                                                  collection?.collection_id
                                                ]?.[order?.order_id] || ""
                                              }
                                              onChange={(event) =>
                                                handleChange(
                                                  event,
                                                  order.order_id,
                                                  collection.collection_id
                                                )
                                              }
                                            />

                                            <button
                                              type="button"
                                              className={`rounded-md bg-green-600 w-full px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-700 ${
                                                !isInputValid
                                                  ? "opacity-50 cursor-not-allowed"
                                                  : ""
                                              }`}
                                              onClick={(event) =>
                                                handleOpen(
                                                  order.order_id,
                                                  collection.collection_id,
                                                  event
                                                )
                                              }
                                              disabled={!isInputValid}
                                            >
                                              Settle
                                            </button>
                                          </div>

                                          <div>
                                            <input
                                              className=" mt-2 rounded-md border whitespace-nowrap bg-white px-3 py-2 text-sm w-40 mb-2"
                                              type="text"
                                              value={
                                                order.total_platform_charges ||
                                                0
                                              }
                                              readOnly={true}
                                            />

                                            <button
                                              type="button"
                                              className={`rounded-md bg-green-600 w-full px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-700 ${
                                                !order.total_platform_charges ||
                                                order.total_platform_charges ===
                                                  0
                                                  ? "opacity-50 cursor-not-allowed"
                                                  : ""
                                              }`}
                                              onClick={(event) => {
                                                handlePlatformChargesOpen(
                                                  order.order_id,
                                                  event
                                                );
                                              }}
                                              disabled={
                                                !order.total_platform_charges ||
                                                order.total_platform_charges ===
                                                  0
                                              }
                                            >
                                              Settle Platform Charges
                                            </button>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                </div>
                              </tr>
                            );
                          })}
                        </tbody>
                        <Modal
                          open={open}
                          onClose={handleClose}
                          aria-labelledby="simple-modal-title"
                          aria-describedby="simple-modal-description"
                        >
                          <Box
                            sx={{
                              position: "absolute",
                              width: 400,
                              height: 120,
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              bgcolor: "background.paper",
                              boxShadow: 24,
                              borderRadius: 24,
                              p: 4,
                            }}
                          >
                            <div className="flex flex-col items-center justify-center space-y-5 h-full">
                              <h2 className="text-2xl font-normal text-center">
                                Are you sure you want to submit
                              </h2>
                              <button
                                type="button"
                                onClick={() => {
                                  settleOrder(enteredAmount);
                                  handleClose();
                                }}
                                className="rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-600/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                              >
                                Submit
                              </button>
                            </div>
                          </Box>
                        </Modal>
                        <Modal
                          open={platformChargesModal}
                          onClose={handlePlatformChargesClose}
                          aria-labelledby="simple-modal-title"
                          aria-describedby="simple-modal-description"
                        >
                          <Box
                            sx={{
                              position: "absolute",
                              width: 400,
                              height: 200,
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              bgcolor: "background.paper",
                              boxShadow: 24,
                              borderRadius: 24,
                              p: 4,
                            }}
                          >
                            <div className="flex flex-col items-center justify-center space-y-5 h-full m-2">
                              <h2 className="text-2xl font-normal text-center">
                                Are You Sure You Want To Settle Platform Charges
                              </h2>
                              <div className="flex">
                                <button
                                  type="button"
                                  onClick={() => {
                                    settlePlatformCharges();

                                    handlePlatformChargesClose();
                                  }}
                                  className="rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-600/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                                >
                                  Yes
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    handlePlatformChargesClose();
                                  }}
                                  className="rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-600/80 focus-visible:outline focus-visible:outline-2 
                                  focus-visible:outline-offset-2 focus-visible:outline-green-600 ml-3"
                                >
                                  No
                                </button>
                              </div>
                            </div>
                          </Box>
                        </Modal>
                        {/* Table footer */}
                        {!collections?.length ? ( // If collections is an empty array
                          <tfoot>
                            <tr>
                              <td colSpan={6} className="text-center py-4">
                                <span className="text-lg font-semibold text-gray-500">
                                  No records found
                                </span>
                              </td>
                            </tr>
                          </tfoot>
                        ) : null}{" "}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Pagination */}
            <div className="flex items-center justify-center pt-2 pb-6">
              <a
                href="#"
                className={`mx-1 cursor-pointer text-xl font-semibold text-gray-900 ${
                  currentPage === 1 ? "cursor-not-allowed" : ""
                }`}
                onClick={goToPreviousPage}
              >
                <span className="hidden lg:block">← Previous</span>
                <span className="block lg:hidden">←</span>
              </a>
              {pageNumbers.map((page) => (
                <a
                  key={page}
                  href="#"
                  className={`mx-1 flex items-center rounded-md border  text-lg  border-gray-400 px-3 py-1 text-gray-900 hover:scale-105 ${
                    page === currentPage ? "bg-gray-900 text-white" : ""
                  }`}
                  onClick={(e) => handlePageClick(e, page)}
                >
                  {page}
                </a>
              ))}
              <a
                href="#"
                className={`mx-2 text-xl  font-semibold text-gray-900 ${
                  currentPage === totalPages ? "cursor-not-allowed" : ""
                }`}
                onClick={goToNextPage}
              >
                <span className="hidden lg:block">Next →</span>
                <span className="block lg:hidden">→</span>
              </a>
            </div>
          </section>
        </div>

        {/*------------------------------------------- Lending Partner Ends--------------------------------------- */}
      </div>
    </div>
  );
};

export default SettlementTracker;
